import { connect } from 'react-redux';

/*global __CLIENT__*/
import PropTypes from 'prop-types';

import React from 'react';
// import { bindActionCreators } from 'redux';
import { Map } from 'immutable';
import { currentUserSelector } from '../reducers/users';
import CreateOrganizationButton from '../components/buttons/CreateOrganizationButton';
import OrganizationCardsContainer from '../components/OrganizationCardsContainer';
import FullScreenModal from '../components/modals/FullScreenModal';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';
import ToastContainer from '../components/ToastContainer';
import { SUPER_USER } from '../shared/constants.js';
import NavBarNew from '../components/toolbars/NavBarNew';
// import { ProjectActions } from '../actions/project';

if (__CLIENT__) {
  require('../styles/Dashboard.css');
}

class Dashboard extends React.Component {
  static propTypes = {
    isSuperUser: PropTypes.bool.isRequired,
    currentUser: PropTypes.instanceOf(Map),
  };

  render() {
    const { isSuperUser, currentUser } = this.props;
    return (
      <div className="main-container">
        <ToastContainer />
        <div className="dashboard-container">
          <NavBarNew />
          <div className="row" style={{ marginLeft: 50 }}>
            <div className="col-xs-12 projects p-3">
              <div className="row">
                <h2 className="section-header">Organizations</h2>
                {isSuperUser && (
                  <div className="button-group float-sm-left ml-3">
                    <CreateOrganizationButton currentUser={currentUser} />
                  </div>
                )}
              </div>
              <div className="row box-container">
                <OrganizationCardsContainer />
              </div>
            </div>
          </div>
        </div>
        <FullScreenModal />
      </div>
    );
  }
}

const dashboardSelector = immutableCreatorSelector(
  [currentUserSelector],
  currentUser => ({
    currentUser,
  }),
);

@connect(dashboardSelector)
export default class DashboardContainer extends React.Component {
  static propTypes = {
    // dispatch: PropTypes.func.isRequired,
    currentUser: PropTypes.instanceOf(Map),
  };

  render() {
    const { currentUser } = this.props;
    const isSuperUser = currentUser.get('role_id') === SUPER_USER;
    return (
      <Dashboard
        currentUser={currentUser}
        isSuperUser={isSuperUser}
        /* {...bindActionCreators(ProjectActions, dispatch)} */
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Organizations.js